var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteBlackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666687 4.99992C0.666687 4.53968 1.03978 4.16658 1.50002 4.16658H16.5C16.9603 4.16658 17.3334 4.53968 17.3334 4.99992C17.3334 5.46016 16.9603 5.83325 16.5 5.83325H1.50002C1.03978 5.83325 0.666687 5.46016 0.666687 4.99992Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33335 2.49992C7.11234 2.49992 6.90038 2.58772 6.7441 2.744C6.58782 2.90028 6.50002 3.11224 6.50002 3.33325V4.16658H11.5V3.33325C11.5 3.11224 11.4122 2.90028 11.2559 2.744C11.0997 2.58772 10.8877 2.49992 10.6667 2.49992H7.33335ZM13.1667 4.16658V3.33325C13.1667 2.67021 12.9033 2.03433 12.4345 1.56548C11.9656 1.09664 11.3297 0.833252 10.6667 0.833252H7.33335C6.67031 0.833252 6.03443 1.09664 5.56559 1.56548C5.09675 2.03433 4.83335 2.67021 4.83335 3.33325V4.16658H3.16669C2.70645 4.16658 2.33335 4.53968 2.33335 4.99992V16.6666C2.33335 17.3296 2.59675 17.9655 3.06559 18.4344C3.53443 18.9032 4.17031 19.1666 4.83335 19.1666H13.1667C13.8297 19.1666 14.4656 18.9032 14.9345 18.4344C15.4033 17.9655 15.6667 17.3296 15.6667 16.6666V4.99992C15.6667 4.53968 15.2936 4.16658 14.8334 4.16658H13.1667ZM4.00002 5.83325V16.6666C4.00002 16.8876 4.08782 17.0996 4.2441 17.2558C4.40038 17.4121 4.61234 17.4999 4.83335 17.4999H13.1667C13.3877 17.4999 13.5997 17.4121 13.7559 17.2558C13.9122 17.0996 14 16.8876 14 16.6666V5.83325H4.00002Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33335 8.33325C7.79359 8.33325 8.16669 8.70635 8.16669 9.16658V14.1666C8.16669 14.6268 7.79359 14.9999 7.33335 14.9999C6.87312 14.9999 6.50002 14.6268 6.50002 14.1666V9.16658C6.50002 8.70635 6.87312 8.33325 7.33335 8.33325Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6667 8.33325C11.1269 8.33325 11.5 8.70635 11.5 9.16658V14.1666C11.5 14.6268 11.1269 14.9999 10.6667 14.9999C10.2065 14.9999 9.83335 14.6268 9.83335 14.1666V9.16658C9.83335 8.70635 10.2065 8.33325 10.6667 8.33325Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteBlackIcon);
export default __webpack_public_path__ + "static/media/delete-black-icon.ac8f042aba752858ec9b6fcbd7d13643.svg";
export { ForwardRef as ReactComponent };